import {useEffect, useRef} from 'react'
import {Link, useLocation} from 'react-router'
import {useCategoryCount} from '@/hooks/useTrips'

const tabConfig = [
    {label: 'Upcoming', path: '/rides/upcoming', category: 'upcoming'},
    {label: 'On Going', path: '/rides/ongoing', category: 'ongoing'},
    {label: 'Completed', path: '/rides/completed', category: 'completed'},
    {label: 'Cancelled', path: '/rides/cancelled', category: 'cancelled'},
]

export default function RideTabNav({activeCategory} = {}) {
    const location = useLocation()
    const containerRef = useRef(null)
    const activeRef = useRef(null)
    const {data: ongoingCount} = useCategoryCount('ongoing')
    const {data: upcomingCount} = useCategoryCount('upcoming')
    const {data: completedCount} = useCategoryCount('completed')
    const {data: cancelledCount} = useCategoryCount('cancelled')

    const counts = {
        '/rides/ongoing': ongoingCount ?? 0,
        '/rides/upcoming': upcomingCount ?? 0,
        '/rides/completed': completedCount ?? 0,
        '/rides/cancelled': cancelledCount ?? 0,
    }

    useEffect(() => {
        const container = containerRef.current
        const active = activeRef.current
        if (!container || !active) return
        const containerRect = container.getBoundingClientRect()
        const activeRect = active.getBoundingClientRect()
        const offset = activeRect.left - containerRect.left - (containerRect.width - activeRect.width) / 2
        container.scrollTo({left: container.scrollLeft + offset, behavior: 'smooth'})
    }, [location.pathname, activeCategory])

    return (
        <div ref={containerRef} className="border border-gray-300 rounded-full p-1 mb-5 max-md:mb-0 flex gap-1 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden md:[&>a]:flex-1">
            {tabConfig.map((tab) => {
                const isActive = activeCategory ? activeCategory === tab.category : location.pathname === tab.path
                return (
                    <Link
                        key={tab.label}
                        to={tab.path}
                        ref={isActive ? activeRef : null}
                        className={`shrink-0 md:shrink flex items-center justify-center gap-1.5 md:py-4 md:px-5 py-3 px-2 max-md:py-2 max-md:px-3 max-md:text-sm rounded-full font-medium cursor-pointer transition-colors duration-200 whitespace-nowrap ${isActive ? 'bg-(--bg-dark) text-white' : 'text-(--bg-dark)'}`}
                    >
                        <span className={`inline-flex items-center justify-center min-w-5 h-5 px-1.5 rounded-full text-xs font-medium max-md:min-w-4 max-md:h-4 max-md:px-1 max-md:text-[10px] ${isActive ? 'bg-(--accent-green-light) text-black' : 'bg-(--bg-dark) text-white'}`}>
                            {counts[tab.path]}
                        </span>
                        {tab.label}
                    </Link>
                )
            })}
        </div>
    )
}
